import * as React from 'react';
import Toast from './Toast';
import { useToaster } from './store';

import './UiToaster.scss';

export default function UiToaster() {
  const { toasts } = useToaster();

  return (
    <div className="toast-container">
      {toasts.map(item => (
        <Toast
          key={item.id}
          id={item.id}
          type={item.type}
          text={item.text}
        />
      ))}
    </div>
  );
}
